import { HaNContext, HaNFilterBarContext } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";
import { ChipFilterNew } from "@molecules";

export const WorkspacesFilters = () => {
  const { tab } = useRequiredContext(HaNContext);

  if (tab !== "workspaces") return null;

  return <WorkspacesFiltersContent />;
};

const WorkspacesFiltersContent = () => {
  const { areFiltersTransparent } = useRequiredContext(HaNFilterBarContext);

  return (
    <ChipFilterNew
      filterSlice="HereAndNow_Workspaces"
      testIdPrefix="HaNWorkSpaceFilters"
      areFilterTransparent={areFiltersTransparent}
    />
  );
};
